/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-toolbox/lib/button';
import Table from 'react-toolbox/lib/table';
import Spinner from '~/components/Spinner';
import Tag from '~/components/Tag';

import styleLocal from './style.scss';

class Locations extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    router: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      query: '',
      results: []
    };
  }

  componentDidMount() {
    this.search();
  }


  search() {
    this.setState({ loading: true });

    const results = Object.values(this.props.locations)
      .filter(i => !i.removed)
      .filter(i => i.name.toLowerCase().startsWith(this.state.query.toLowerCase()));

    this.setState({
      results,
      loading: false
    });
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        <div className={styleLocal.title}>Locations</div>
        <Button
          label="New Location"
          onClick={() => this.context.dialogPush('locationNew', { onCreate: () => this.search() })}
          primary
          raised
          className={styleLocal.buttonNew}
          icon="add"
        />
        <form style={{ marginBottom: 15 }} onSubmit={e => { e.preventDefault(); this.search(); }}>
          <input
            placeholder="Search Name"
            className={styleLocal.searchField}
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value })}
          />
          <Button label="Find" primary raised type="submit" />
        </form>
        {!this.state.loading && this.state.results.length > 0 && <Table
          className={styleLocal.table}
          selectable={false}
          model={{
            location: { type: String },
          }}
          source={this.state.results
            .map(i => {
              return {
                location: (<Tag id={i.id} type="location" />),
              };
            })}
        />}
        {this.state.loading && <Spinner className={styleLocal.spinner} />}
        {!this.state.loading && this.state.results.length === 0 && 'No Locations found'}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locations: state.getIn(['locations', 'locations']).toJS(),
});

export default connect(mapStateToProps)(Locations);



// WEBPACK FOOTER //
// ./app/pages/Locations/index.js